/**
 * Frontend env. Vite exposes env vars prefixed with VITE_ at build time.
 * Set these in .env.local for dev and in Cloudflare Pages env panel for prod.
 *
 * When a value is unset, app shows a clear "not configured" message — never
 * silently fails (Engineering Principle #5).
 */

interface FrontendEnv {
  clerkPublishableKey: string | undefined;
  apiBaseUrl: string;
}

export const env: FrontendEnv = {
  clerkPublishableKey: import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as string | undefined,
  apiBaseUrl:
    (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? "http://localhost:3001",
};

export function isClerkConfigured(): boolean {
  return Boolean(env.clerkPublishableKey && env.clerkPublishableKey.length > 0);
}
